import {Currency} from './currency.model';

export interface IDenomination {
  price?: number;
  currency?: Currency;
  stock: string;
}

export class Denomination implements IDenomination {
  constructor(
    public price?:number,
    public currency?: Currency,
    public stock: string = 'IN_STOCK',
    public isCustom: boolean = false
  ) {}
}
